import { SessionQuestion } from '@/assets/types'
import { getToken } from '@/assets/utils'
import { useClockStore } from './clock'

export interface ChannelEvents {
    create: (document: any) => void
    update: (document: any) => void
    delete: (document: any) => void
    error?: () => Promise<void>
}

export function handleSubscription(collection: string, channelEvents: ChannelEvents) {
    const url = `${import.meta.env.VITE_REALTIME_ENDPOINT}/${collection}`

    const eventSource = new EventSource(url)

    if (channelEvents.error) {
        eventSource.addEventListener(
            "error",
            async () => {
                await channelEvents.error()
            }
        )
    }

    eventSource.addEventListener(
        "create",
        (evt) => {
            const doc: any = JSON.parse(evt.data)
            channelEvents.create(
                doc
            )
        }
    )

    eventSource.addEventListener(
        "update",
        (evt) => {
            const doc: any = JSON.parse(evt.data)
            channelEvents.update(
                doc
            )
        }
    )

    eventSource.addEventListener(
        "delete",
        (evt) => {
            const doc: any = JSON.parse(evt.data)
            channelEvents.delete(
                doc
            )
        }
    )

    return () => { eventSource.close() }
}

export function newSessionQuestion(index: number, data: any) {
    const clockStore = useClockStore()
    const startTime = clockStore.serverTime
    return {
        index: index,
        title: data.title,
        image: data.image || undefined,
        startTime: startTime, // Start time
        endTime: startTime + ((data.timeout ?? 60) * 1000), // defaults to 1 minute
        answers: data.answers.map((a: any) => ({
            title: a.text || undefined,
            image: a.image || undefined,
        })),
        correctAnswer: null, // will be set when the question is closed
        threshold: data.threshold ?? 100,
        type: data.type ?? "question"
    } as SessionQuestion
}